import { LinkValue, ValueLabel } from './ContactLink.styled';
import { ContactLinkType } from './contants';
import { CSSProperties } from 'react';

interface IContactLinkProps {
  value: string;
  type: ContactLinkType;
  fontSize?: string;
  style?: CSSProperties;
  stopEventPropagation?: boolean;
}

export const ContactLink = ({
  value,
  type,
  fontSize,
  style,
  stopEventPropagation,
}: IContactLinkProps) => {
  const url = `${type === ContactLinkType.PHONE ? 'tel:' : 'mailto:'}${value}`;

  const handleClick = (e: any) => {
    stopEventPropagation && e.stopPropagation();
  };

  return (
    <LinkValue href={url} onClick={handleClick}>
      <ValueLabel style={style} fontSize={fontSize}>
        {value}
      </ValueLabel>
    </LinkValue>
  );
};

export default ContactLink;
